import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromReducer from './dealer.reducer';
import * as fromAdapter from './dealer.adapter';
import * as util from '../../shared/services/util.service';
import {FeatureKeys} from '../app.reducer';
import {IDealerInfo, ISalesInfo, IServiceInfo} from '@signal/asp-data-commons';

const selectDealerFeature = createFeatureSelector<fromReducer.DealerState>(
  FeatureKeys.DEALER
);

export const dealerDetails = createSelector(
  selectDealerFeature,
  (state: fromReducer.DealerState) => state.dealerInfo
);

export const dealerDetailsData = createSelector(
  selectDealerFeature,
  (state: fromReducer.DealerState) => state.dealerInfo.data
);
export const dealerDashboardOverlayDetails = createSelector(
  selectDealerFeature,
  (getDashboardContents: fromReducer.DealerState) => getDashboardContents.contents.data
);

export const selectDealerCode = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => util.dealerCd || dealerInfo?.dealerCode || ''
);

export const selectServiceDetails = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.service
);

export const selectSalesDetails = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.sales
);

export const selectDealerName = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.dealerName
);

export const selectDealerAddress = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.addressShort
);

export const selectDealerAddressLong = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.address
);

export const selectDealerPhoneNumber = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.phoneNumber
);

export const selectSalesOperationalHours = createSelector(
  selectSalesDetails,
  (sales: ISalesInfo) => sales?.hoursOfOperation.find(x => x.day.toUpperCase() === fromAdapter.dayOfWeek()).operation
);

export const selectServiceOperationalHours = createSelector(
  selectServiceDetails,
  (service: IServiceInfo) => service?.hoursOfOperation.find(x => x.day.toUpperCase() === fromAdapter.dayOfWeek()).operation
);

export const selectSalesAmenities = createSelector(
  selectSalesDetails,
  (sales: ISalesInfo) => sales?.amenities
);

export const selectServiceAmenities = createSelector(
  selectServiceDetails,
  (service: IServiceInfo) => service?.amenities
);

export const selectLatitude = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.latitude
);

export const selectLongitude = createSelector(
  dealerDetailsData,
  (dealerInfo: IDealerInfo) => dealerInfo?.longitude
);

export const selectPdiChecklist = createSelector(
  selectSalesDetails,
  (sales: ISalesInfo) => sales?.pdiChecklist
);

export const selectServiceShowPricing = createSelector(
  selectServiceDetails,
  (service: IServiceInfo) => service?.showPricing
);

export const selectStates = createSelector(
  selectDealerFeature,
  (state: fromReducer.DealerState) => state.states.data
);

export const selectCities = createSelector(
  selectDealerFeature,
  (state: fromReducer.DealerState) => state.cities.data
);

